import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Container, Label } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import TicketCard from "./TicketCard";
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { createTicket } from '../../actions/index';

class CreateTicketScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tickets: [
                {
                    id: 1,
                    name: i18n.t('screens:createTicketScreen.ticketOrderSupport'),
                    icon: "shopping_cart"
                },
                {
                    id: 2,
                    name: i18n.t('screens:createTicketScreen.ticketMenuChange'),
                    icon: "restaurant_menu"
                },
                {
                    id: 3,
                    name: i18n.t('screens:createTicketScreen.ticketHardwareSupport'),
                    icon: "build"
                },
                {
                    id: 4,
                    name: i18n.t('screens:createTicketScreen.ticketTechnicalSupport'),
                    icon: "computer"
                },
                {
                    id: 5,
                    name: i18n.t('screens:createTicketScreen.ticketBillingAccount'),
                    icon: "account_circle"
                },
                {
                    id: 6,
                    name: i18n.t('screens:createTicketScreen.ticketFeatureRequestProductFeedback'),
                    icon: "feedback"
                },
                {
                    id: 7,
                    name: i18n.t('screens:createTicketScreen.ticketOther'),
                    icon: "headset_mic"
                }
            ],
            attachments: [],
            selectedTicket: {},
            issueSubject: "",
            issueDetails: "",
            createTicketStep: 1
        };

        this.selectTicket = this.selectTicket.bind(this);
        this.onChange = this.onChange.bind(this);
        this.changeState = this.changeState.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.resetState = this.resetState.bind(this);
        this.resetAttachmentState = this.resetAttachmentState.bind(this);

    }

    resetState() {
        this.state.attachments = [];
        this.state.selectedTicket = {};
        this.state.issueSubject = "";
        this.state.issueDetails = "";
        this.state.createTicketStep = 1;
    }

    resetAttachmentState() {

        let attachmentsCount = 6;

        for (let i = 1; i < attachmentsCount; i++) {
            let element = document.getElementById('file' + i);
            console.log(element);
            if (element && element.value) {
                element.value = null;
            }
        }

        this.state.attachments = [];
    }

    selectTicket(ticket) {

        const nextStep = this.state.createTicketStep + 1;
        const changeCondition = this.state.selectedTicket && this.state.selectedTicket.id !== ticket.id;

        this.setState({
            ...this.state,
            selectedTicket: Object.assign({}, this.state.selectedTicket,
                {
                    id: (changeCondition) ? ticket.id : -1,
                    name: ticket.name,
                    icon: ticket.icon
                }),
            createTicketStep: (changeCondition) ? nextStep : 1,
        })
    }

    onSubmit(e) {
        e.preventDefault(); // Stop form submit

        const successCallback = () => {
            this.resetState();
        };

        const errorCallback = () => {
            this.resetAttachmentState();
        };

        const data = {
            attachments: this.state.attachments,
            subject: this.state.selectedTicket.name + " " + this.state.issueSubject,
            body: this.state.issueDetails
        }

        this.props.createTicket(data, successCallback, errorCallback)
    }

    onChange({ target }) {

        if (target.files && target.files[0]) {
            this.setState({
                ...this.state,
                attachments: [...this.state.attachments, { [target.name]: target.files[0] }]
            });
        }
    }

    changeState({ target }) {
        this.setState({ [target.name]: target.value });
    }

    goToRestaurantsScreen() {
        this.props.history.push('/restaurants');
    }

    renderHeading() {
        const { screenHeading } = styles;

        return (
            <Col sm={3} style={screenHeading}>
                <div>
                    <MaterialIcon icon="note_add" color="#0288d1" size={22} />
                    &nbsp;{i18n.t('screens:createTicketScreen.screenTitle')}
                </div>
            </Col>
        );
    }

    selectStep(step) {
        this.setState({
            createTicketStep: step
        })
    }

    renderCreateTicketSteps() {
        const ticketId = this.state.selectedTicket.id;
        const step = this.state.createTicketStep;

        switch (step) {
            case 1:
                return this.renderSupportTickets();
            case 2:
                if (ticketId !== 1) {
                    return this.renderIssueDetailsContainer();
                } else {
                    return this.renderOrderSupportInfo();
                }
            case 3:
                return this.renderIssueDetailsContainer();
            default:
                return this.renderSupportTickets();
        }

    }

    renderSupportTickets() {
        const { ticketsContainer } = styles;

        return (
            <Fragment>
                <Col md={12} style={ticketsContainer}>
                    {
                        this.state.tickets.map((ticket, i) => {

                            const backgroundColor = '#fafafa';
                            const iconColor = (ticket.id == this.state.selectedTicket.id) ? '#0288d1' : '#757575';
                            const ticketBorder = (ticket.id == this.state.selectedTicket.id) ? '1px solid #0288d1' : '1px solid lightgray';
                            const textColor = (ticket.id == this.state.selectedTicket.id) ? '#0288d1' : '#000';

                            return (
                                <TicketCard
                                    ticket={ticket}
                                    backgroundColor={backgroundColor}
                                    ticketBorder={ticketBorder}
                                    iconColor={iconColor}
                                    textColor={textColor}
                                    selectTicket={this.selectTicket}
                                />
                            )

                        })
                    }
                </Col>
                {(this.state.selectedTicket.id && this.state.selectedTicket.id !== -1) ? this.renderNextStepButton() : null}
            </Fragment>
        )
    }

    renderNextStepButton() {
        const { alignItemRight } = styles;

        const nextStep = this.state.createTicketStep + 1;
        const colWidth = (this.state.createTicketStep == 1) ? 12 : 6;

        return (
            <Col md={colWidth} style={Object.assign({ marginTop: 20 }, alignItemRight)}>
                <Button style={{ width: 125, display: 'flex', justifyContent: 'center', alignItems: 'center' }} color="primary" onClick={() => this.selectStep(nextStep)} >
                    <span style={{ padding: '0px 8px' }}>{i18n.t('common:buttons.continue')}</span>
                    <MaterialIcon icon="navigate_next" color="#fff" size={24} />
                </Button>
            </Col>
        )
    }

    renderCreateTicketButton() {
        const { alignItemRight } = styles;

        return (
            <Col md={6} style={Object.assign({ padding: 0 }, alignItemRight)}>
                <Button sm={5} style={{ width: 125, display: 'flex', alignItems: 'center', justifyContent: 'center'}} color="primary">
                    <span style={{ padding: '0px 8px' }}>{i18n.t('common:buttons.create')}</span>
                    <MaterialIcon icon="send" color="#fff" size={22} />
                </Button>
            </Col>
        )
    }

    renderDoneButton() {
        const { alignItemRight } = styles;

        return (
            <Col md={6} style={Object.assign({ padding: 0 }, alignItemRight)}>
                <Button style={{ width: 125, display: 'flex', alignItems: 'center', justifyContent: 'center' }} color="primary" onClick={() => this.goToRestaurantsScreen()}>
                    <span style={{ padding: '0px 8px' }}>{i18n.t('common:buttons.done')}</span>
                    <MaterialIcon icon="done" color="#fff" size={20} />
                </Button>
            </Col>
        )
    }

    renderPreviousStepButton() {
        const { alignItemLeft } = styles;

        const prevStep = this.state.createTicketStep - 1;

        return (
            <Col md={6} style={Object.assign({ paddingLeft: 40 }, alignItemLeft)}>
                <Button style={{ width: 125, display: 'flex', justifyContent: 'center', alignItems: 'center' }} color="primary" onClick={() => this.selectStep(prevStep)} >
                    <MaterialIcon icon="navigate_before" color="#fff" size={24} />
                    <span style={{ padding: '0px 2px' }}>{i18n.t('common:buttons.back')}</span>
                </Button>
            </Col>
        )
    }

    renderOrderSupportInfo() {
        const { issueDetailsContainer, centerItem, orderInfoMsg, spaceBetweenContainer } = styles;

        return (
            <Fragment>
                <Col md={12} style={Object.assign({}, issueDetailsContainer)} >
                    <div style={centerItem}>
                        <MaterialIcon icon="info" color="#dbdadb" size={40} />
                    </div>
                    <p style={Object.assign({}, centerItem, orderInfoMsg)}>
                        {i18n.t('screens:createTicketScreen.orderInfoMsg')}
                    </p>
                </Col>
                <Col md={12} style={spaceBetweenContainer}>
                    {this.renderPreviousStepButton()}
                    {this.renderDoneButton()}
                </Col>
            </Fragment>
        )
    }

    renderIssueCategory() {
        const { alignInRow, ticketCategory, ticketIcon } = styles;
        const { selectedTicket } = this.state;

        return (
            <div style={alignInRow}>
                <Label for="issueCategory" sm={1} >{i18n.t('screens:createTicketScreen.category')}</Label>
                <Col sm={4} style={{ marginLeft: 12 }}>
                    <p style={ticketCategory}>
                        <span style={ticketIcon}>
                            <MaterialIcon icon={selectedTicket.icon} size={22} />
                        </span>
                        {selectedTicket.name}
                    </p>
                </Col>
            </div>
        )
    }

    renderIssueSubject() {
        const { alignInRow } = styles;

        return (
            <AvGroup style={alignInRow}>
                <Label for="issueSubject" sm={1}>{i18n.t('screens:createTicketScreen.subject')}</Label>
                <Col sm={4} style={{ marginLeft: 12 }}>
                    <AvInput type="input" name="issueSubject" id="issueSubject" onChange={this.changeState} required={true} />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </Col>
            </AvGroup>
        )
    }

    renderIssueDetails() {
        const { alignInRow, detailsTextarea } = styles;

        return (
            <AvGroup style={alignInRow}>
                <Label for="issueSubject" sm={1}>{i18n.t('screens:createTicketScreen.bodyDetails')}</Label>
                <Col sm={10} style={{ marginLeft: 12 }}>
                    <AvInput type="textarea" name="issueDetails" id="issueDetails" style={detailsTextarea} onChange={this.changeState} required={true} />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </Col>
            </AvGroup>
        )
    }

    renderFileAttachments() {
        const { displayWrap, attachmentInfoMsg } = styles;

        return (
            <Col md={12} style={Object.assign({ padding: 0 }, displayWrap)}>
                <Label sm={12}>{i18n.t('screens:createTicketScreen.attachments')}</Label>
                <Col md={4}>{this.renderFileInput(1)}</Col>
                <Col md={4}>{this.renderFileInput(2)}</Col>
                <Col md={4}>{this.renderFileInput(3)}</Col>
                <Col md={4}>{this.renderFileInput(4)}</Col>
                <Col md={4}>{this.renderFileInput(5)}</Col>
                <Col md={12}>
                    <p style={attachmentInfoMsg}>{i18n.t('screens:createTicketScreen.attachmentInfoMsg')}</p>
                </Col>
            </Col>
        )
    }

    renderFileInput(fileNumber) {
        const { alignInRow } = styles;
        const fileName = `file${fileNumber}`;

        return (
            <div style={alignInRow}>
                <input type="file" name={fileName} id={fileName} onChange={this.onChange} requred={false} />
            </div>
        );
    }

    renderIssueDetailsContainer() {
        const { issueDetailsContainer, spaceBetweenContainer } = styles;

        return (
            <Fragment>
                <AvForm onValidSubmit={this.onSubmit}>
                    <Col md={12} style={Object.assign({}, issueDetailsContainer)} >
                        {this.renderIssueCategory()}
                        {this.renderIssueSubject()}
                        {this.renderIssueDetails()}
                        {this.renderFileAttachments()}
                    </Col>
                    <Col md={12} style={spaceBetweenContainer}>
                        {this.renderPreviousStepButton()}
                        {this.renderCreateTicketButton()}
                    </Col>
                </AvForm>
            </Fragment>
        )
    }

    render() {
        return (
            <Container>
                {this.renderHeading()}
                {this.renderCreateTicketSteps()}
            </Container>
        )
    }
}


const mapStateToProps = state => {
    return {
    };
};

export default connect(mapStateToProps, { createTicket })(CreateTicketScreen);

let styles = {
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginTop: 20,
        paddingLeft: 0,
        color: '#0288d1'
    },
    issueDetailsContainer: {
        marginLeft: 15,
        marginTop: 20,
        backgroundColor: 'rgb(250, 250, 250)',
        borderLeft: '1px solid rgb(2, 136, 209)',
        paddingTop: 10,
        paddingBottom: 10,
        height: 430
    },
    chooseFileInput: {
        paddingTop: 'calc(0.375rem + 1px)',
        paddingBottom: 'calc(0.375rem + 1px)',
        lineHeight: 1.5
    },
    ticketsContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
        marginTop: 20,
        marginLeft: 15,
        backgroundColor: 'rgb(250, 250, 250)',
        borderLeft: '1px solid rgb(2, 136, 209)',
        paddingBottom: 10,
        height: 430
    },
    centerItem: {
        display: 'flex',
        justifyContent: 'center'
    },
    alignItemRight: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    alignItemLeft: {
        display: 'flex',
        justifyContent: 'flex-start'
    },
    orderInfoMsg: {
        marginTop: 20
    },
    spaceBetweenContainer: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'space-between'
    },
    alignInColumn: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'column'
    },
    alignInRow: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row'
    },
    detailsTextarea: {
        height: 80
    },
    displayWrap: {
        marginTop: 10,
        display: 'flex',
        flexFlow: 'row wrap'
    },
    ticketCategory: {
        margin: '8px 0px 0px 0px'
    },
    ticketIcon: {
        padding: '0px 6px 2px 0px'
    },
    attachmentInfoMsg: {
        fontSize: 14,
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 10
    }
}


// WEBPACK FOOTER //
// ./src/components/support/CreateTicketScreen.js